module.exports = __webpack_public_path__ + "img/LTS_SBT.48551b88.gif";